// https://mock.memeyule.com/project/16/interface/api/cat_4029

import { request } from 'lib';
import { getRoomId } from '../../lib/room';

const loadHistory = () => {
  return request.cryolite.get('/api/v1/oath/rite-list', {
    roomId: getRoomId(),
  });
};

const loadStatus = () => {
  return request.cryolite.get('/api/v1/oath/status', {
    roomId: getRoomId(),
  });
};

export default {
  loadHistory,
  loadStatus,
};
